import { useContext, Context } from 'react';

const useContextWithWithError = <T>(context: Context<T>, name: string) => {
    const contextValue = useContext(context);

    if (!contextValue) {
        throw new Error(`${name} must be used within a ${name} Provider`);
    }

    return contextValue;
};

export default useContextWithWithError;
